import { isSameDay } from 'date-fns/isSameDay'

import { ContributorRole } from '../../../../types'
import { compareHours } from '../../../../utils'
import i18n from '../../../../i18n'

import heartImg from '../../../../../assets/icons8-medical-heart-96.png'
import lungsImg from '../../../../../assets/icons8-lungs-96.png'
import vasculaireImg from '../../../../../assets/vasculaire.png'
import congenitalImg from '../../../../../assets/congenital.png'
import { SubEvents } from '../../../../types'

export const personSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1phnduy" focusable="false" aria-hidden="true" viewBox="0 0 24 24" fill="${color}"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"></path></svg></div>`

export const speakSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1phnduy" focusable="false" aria-hidden="true" viewBox="0 0 24 24" fill="${color}"><circle cx="9" cy="9" r="4"></circle><path d="M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4m7.76-9.64-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27M20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14"></path></svg></div>`

export const supervisorSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1phnduy" focusable="false" aria-hidden="true" viewBox="0 0 24 24" fill="${color}"><path d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m3.61 6.34c1.07 0 1.93.86 1.93 1.93s-.86 1.93-1.93 1.93-1.93-.86-1.93-1.93c-.01-1.07.86-1.93 1.93-1.93m-6-1.58c1.3 0 2.36 1.06 2.36 2.36s-1.06 2.36-2.36 2.36-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36m0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68M11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09"></path></svg></div>`

export const placeSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DomainIcon" tabindex="-1" title="Domain" fill="${color}"><path d="M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"></path></svg></div>`

export const roomSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MeetingRoomIcon" tabindex="-1" title="MeetingRoom" fill="${color}"><path d="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6zm-4 5v2h2v-2z"></path></svg></div>`

export const outsideRoomSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="HomeWorkIcon" fill="${color}"><path d="M1 11v10h5v-6h4v6h5V11L8 6z"></path><path d="M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3zm9 6h-2V7h2z"></path></svg></div>`

export const bookmarkSVG = (color = 'black', size = '1.5rem') =>
  `<div style="min-height:${size};min-width:${size};max-height:${size};max-width:${size};"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarkAddedIcon" tabindex="-1" title="BookmarkAdded" fill="${color}"><path d="m19 21-7-3-7 3V5c0-1.1.9-2 2-2h7c-.63.84-1 1.87-1 3 0 2.76 2.24 5 5 5 .34 0 .68-.03 1-.1zM17.83 9 15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41z"></path></svg></div>`

export const heartSrc = heartImg

export const lungsSrc = lungsImg

export const vasculaireSrc = vasculaireImg

export const congenitalSrc = congenitalImg

export const onDateSet = (
  view: { type: string; currentStart: Date | string },
  viewType: [string],
  subEvents: SubEvents[] | undefined,
  [slotMinTime, setMinTime]: [string, React.Dispatch<React.SetStateAction<string>>],
  [slotMaxTime, setMaxTime]: [string, React.Dispatch<React.SetStateAction<string>>],
  initialMinTime: string,
  initialMaxTime: string
) => {
  if (viewType.includes(view.type)) {
    const currentDate = new Date(view.currentStart)
    let newSlotMinTime: Date | undefined
    let newSlotMaxTime: Date | undefined

    subEvents?.forEach(subEv => {
      // Check if subEvent start and end is in the same day
      if (isSameDay(subEv.start, subEv.end) && isSameDay(subEv.start, currentDate)) {
        if (newSlotMinTime === undefined) {
          newSlotMinTime = new Date(subEv.start)
        } else {
          newSlotMinTime =
            compareHours(subEv.start, newSlotMinTime) === -1
              ? new Date(subEv.start)
              : newSlotMinTime
        }
        if (newSlotMaxTime === undefined) {
          newSlotMaxTime = new Date(subEv.end)
        } else {
          newSlotMaxTime =
            compareHours(subEv.end, newSlotMaxTime) === 1 ? new Date(subEv.end) : newSlotMaxTime
        }
        // Or if subEvent start is in the same day but not end
      } else if (isSameDay(subEv.start, currentDate)) {
        if (newSlotMinTime === undefined) {
          newSlotMinTime = new Date(subEv.start)
        } else {
          newSlotMinTime =
            compareHours(subEv.start, newSlotMinTime) === -1
              ? new Date(subEv.start)
              : newSlotMinTime
        }
        // We set the newSlotMaxTime to 24h00 because end is in next day
        if (newSlotMaxTime === undefined) {
          newSlotMaxTime = new Date(subEv.start)
        } else {
          newSlotMaxTime.setHours(24, 0, 0, 0)
        }
        // Or if subEvent end is in the same day but not start
      } else if (isSameDay(subEv.end, currentDate)) {
        // We set the newSlotMinTime to 00h00 because start is in previous day
        if (newSlotMinTime === undefined) {
          newSlotMinTime = new Date(subEv.end)
        } else {
          newSlotMinTime.setHours(0, 0, 0, 0)
        }
        if (newSlotMaxTime === undefined) {
          newSlotMaxTime = new Date(subEv.end)
        } else {
          newSlotMaxTime =
            compareHours(subEv.end, newSlotMaxTime) === 1 ? new Date(subEv.end) : newSlotMaxTime
        }
      }
    })

    setMinTime(
      newSlotMinTime
        ? `${new Date(newSlotMinTime).getHours().toLocaleString(i18n.resolvedLanguage, { minimumIntegerDigits: 2 })}:${new Date(newSlotMinTime).getMinutes().toLocaleString(i18n.resolvedLanguage, { minimumIntegerDigits: 2 })}:00`
        : slotMinTime
    )
    setMaxTime(
      newSlotMaxTime
        ? `${new Date(newSlotMaxTime).getHours().toLocaleString(i18n.resolvedLanguage, { minimumIntegerDigits: 2 })}:${new Date(newSlotMaxTime).getMinutes().toLocaleString(i18n.resolvedLanguage, { minimumIntegerDigits: 2 })}:00`
        : slotMaxTime
    )
  } else {
    setMinTime(initialMinTime)
    setMaxTime(initialMaxTime)
  }
}

export const selectContributorSVG = (
  role: ContributorRole | ContributorRole[],
  color = 'black',
  size = '1.5rem'
): string => {
  if (Array.isArray(role)) {
    return role.map(r => selectContributorSVG(r, color, size)).join('')
  }
  switch (role) {
    case ContributorRole.Speaker:
      return speakSVG(color, size)
    case ContributorRole.Supervisor:
      return supervisorSVG(color, size)
    default:
      return personSVG(color, size)
  }
}
